import React from 'react';
import Page from '../components/ui/Page';
import EmptyState from '../components/ui/EmptyState';

// Phase 4 builds this out (buckets, queue, detail panel, quarantine/assign/fix).
export default function TriagePage() {
  return (
    <Page maxW="7xl">
      <EmptyState emoji="🧭" title="Triage queue" subtitle="Coming in the next build step." />
    </Page>
  );
}
